// A spread contains either one landscape image or up to two portrait images.
// Each portrait run has two alignments, independent of earlier landscape pages.
function pageCount(total) {
    const value = Number(total);
    return Number.isFinite(value) ? Math.max(0, Math.floor(value)) : 0;
}

function widePageSet(flags) {
    if (flags instanceof Set) return flags;
    const wide = new Set();
    Object.entries(flags || {}).forEach(([index, value]) => {
        if (Number(value)) wide.add(Number(index) + 1);
    });
    return wide;
}

export function buildSpreads(total, widePages = null, offset = false) {
    const count = pageCount(total);
    const wide = widePageSet(widePages);
    const result = [];
    for (let page = 1; page <= count;) {
        if (wide.has(page)) {
            result.push([page++]);
            continue;
        }
        const end = (() => {
            let next = page;
            while (next <= count && !wide.has(next)) next++;
            return next;
        })();
        if (offset) result.push([page++]);
        while (page < end) {
            const pair = [page++];
            if (page < end) pair.push(page++);
            result.push(pair);
        }
    }
    return result;
}

export function spreadPages(page, total, widePages = null, offset = false) {
    const count = pageCount(total);
    if (!count) return [];
    const target = Math.max(1, Math.min(Math.floor(Number(page)) || 1, count));
    return buildSpreads(count, widePages, offset).find(pair => pair.includes(target)) || [target];
}

export function spreadStart(page, total, widePages = null, offset = false) {
    return spreadPages(page, total, widePages, offset)[0] || 1;
}

// Old chapter-only keys collide between different manga. Do not migrate them.
export const OFFSET_STORAGE = 'reader-page-offsets-v2';
export function offsetKey(comic, chapter) {
    return comic && comic.slug && chapter && chapter.slug_lang_vol_ch_sub
        ? JSON.stringify([comic.slug, chapter.slug_lang_vol_ch_sub]) : null;
}

function readOffsets(storage) {
    const value = JSON.parse(storage.getItem(OFFSET_STORAGE) || '{}');
    return value && typeof value === 'object' && !Array.isArray(value) ? value : {};
}

export function readPageOffset(storage, key) {
    try {
        const value = key ? readOffsets(storage)[key] : null;
        return typeof value === 'boolean' ? value : null;
    } catch (_) { return null; }
}

export function writePageOffset(storage, key, value) {
    if (!key) return;
    try {
        let offsets;
        try { offsets = readOffsets(storage); } catch (_) { offsets = {}; }
        if (value === null) delete offsets[key];
        else offsets[key] = Boolean(value);
        storage.setItem(OFFSET_STORAGE, JSON.stringify(offsets));
    } catch (_) { /* The current session still works when storage is unavailable. */ }
}
